import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/demo_page/main'
import Homeone from '@/demo_page/home_one'
import Hometwo from '@/demo_page/home_two'
import Homethree from '@/demo_page/home_three'
import Navbar from '@/components/navbar'
import NewNavbar from '@/components/newNavbarPublic'
import About from '@/components/about'
import Produk from '@/components/produk'
import Choose from '@/components/choose'
import Support from '@/components/support'
import Feature from '@/components/feature'
import Screenshots from '@/components/screenshots'
import Team from '@/components/team'
import LatestBlog from '@/components/latest_blog'
import Price from '@/components/price'
import Testimonial from '@/components/testimonial'
import ContactUs from '@/components/contact_us'
import Subscribe from '@/components/subscribe'
import Map from '@/components/map'
import Tile from '@/components/tile'
import Footer from '@/components/footer'
import PageNotFound from '@/components/pagenotfound'
import js from '@/components/js'
import Bloglist from '@/blog/blog_list'
import BlogDetails from '@/blog/blog_details'
import BlogLeftSide from '@/blog/blog_leftside'
import BlogRightSide from '@/blog/blog_rightside'
import BlogLeftSidebar from '@/blog/blog_left_sidebar'
import BlogRightSidebar from '@/blog/blog_right_sidebar'
import Signin from '@/pages/sign_in'
import Signup from '@/pages/sign_up'
import ForgetPassword from '@/pages/forget_Password'
import Review from '@/pages/review'
import Thankyou from '@/pages/thank_you'

import download from '@/pages/download'
import comingsoon from '@/pages/coming_soon'
import Emailtemplate from '@/pages/email_template'
import color from '@/components/color'
import NavbarBlog from '../components/navbar_blog'
import Tabs from '@/components/tabs'

import DashboardMitra from '../public/dashboard-mitra'
import Dashboard from '../public/dashboard'
import Login from '../public/auth/login'
import Register from '../public/auth/register'

import Index from '@/public/index'
import ListProduk from '@/public/list-produk'
import DetailProduk from '@/public/detail-produk'
import LayananKami from '@/public/layanan-kami'
import PengajuanSaya from '@/public/pengajuan-saya'
import AgencyDashboard from '@/public/agency-dashboard'
import Riwayat from '@/public/riwayat'
import ProdukMitra from '@/public/dashboard/product-on-mitra'
import TestimoniUmum from '@/public/testimoni-umum'
import TentangKami from '@/public/tentang-kami'
import Faq from '@/public/faq'
import PengajuanSaya2 from '@/public/pengajuan-saya2'
import Syarat from '@/public/syarat'
import Privasi from '@/public/privasi'

import PembiayaanForm from '@/public/dashboard/pembiayaan-form'
import ProductForm from '@/public/dashboard/product-form'
import BankForm from '@/public/dashboard/bank-form'
import EmailVerified from '../public/auth/EmailVerified'
import RevisionProfile from '../public/auth/RevisionProfile'
import waitingVerifiedEmail from '../public/auth/waitingVerifiedEmail'
import defaultPasswordChange from '../public/auth/defaultPasswordChange'
import ForgotPassword from '../public/auth/ForgotPassword'
import ResetPassword from '../public/auth/ResetPassword'

import ShowFunder from '../public/dashboard/show-funder'
import ShowPengajuan from '../public/dashboard/show-pengajuan'
import ShowPengajuanLending from '../public/dashboard/show-pengajuan-lending'
import ShowPengajuanCorporate from '../public/dashboard/show-pengajuan-corporate'

import axios from 'axios'
import header from '../api/auth/header'
import checkAgreementStatus from '../helpers/agreementStatus'
import ListProdukLending from '../public/list-produk-lending.vue'
import DetailProdukLending from '../public/detail-produk-lending.vue'
import ListLendingDetail from '../public/list-lending-detail.vue'
import ProductLendingDetail from '../public/detail-produk-lending.vue'
import Whistleblower from '../public/whistleblower.vue'
import ListProdukDeposito from '../public/list-produk-deposito.vue'
import ListProdukTabungan from '../public/list-produk-tabungan.vue'
import ListProdukDepositoDetail from '../public/list-produk-deposito-detail.vue'
import ListProdukTabunganDetail from '../public/list-produk-tabungan-detail.vue'
import NewRegister from '../public/auth/NewRegister.vue'
import NewLogin from '../public/auth/newLogin.vue'
import ShowFunderCorporate from '../public/dashboard/show-funder-corporate.vue'

Vue.use(Router)
Vue.component('Navbar', Navbar)
Vue.component('About', About)
Vue.component('Produk', Produk)
Vue.component('Choose', Choose)
Vue.component('Support', Support)
Vue.component('Feature', Feature)
Vue.component('Screenshots', Screenshots)
Vue.component('Team', Team)
Vue.component('Latest-blog', LatestBlog)
Vue.component('Price', Price)
Vue.component('Testimonial', Testimonial)
Vue.component('Contact_us', ContactUs)
Vue.component('Subscribe', Subscribe)
Vue.component('Map', Map)
Vue.component('Footer', Footer)
Vue.component('BlogList', Bloglist)
Vue.component('BlogDetails', BlogDetails)
Vue.component('BlogLeftSide', BlogLeftSide)
Vue.component('BlogRightSide', BlogRightSide)
Vue.component('BlogLeftSidebar', BlogLeftSidebar)
Vue.component('BlogRightSidebar', BlogRightSidebar)
Vue.component('Signin', Signin)
Vue.component('Signup', Signup)
Vue.component('ForgetPassword', ForgetPassword)
Vue.component('Thankyou', Thankyou)
Vue.component('Review', Review)
Vue.component('Faq', Faq)
Vue.component('download', download)
Vue.component('comingsoon', comingsoon)
Vue.component('Emailtemplate', Emailtemplate)
Vue.component('js', js)
Vue.component('Tile', Tile)
Vue.component('color', color)
Vue.component('dashboard-mitra', DashboardMitra)

// Sesi hanya boleh dibuang kalau server benar-benar menyatakan token tidak berlaku.
// Sebelumnya semua kegagalan `/auth/me` masuk ke catch yang sama, sehingga gangguan
// sementara (jaringan putus, timeout, 5xx dari Cloudflare) ikut me-logout user.
// API mengirim 401 dalam dua bentuk: HTTP 401, atau HTTP 200 dengan meta.code 401.
function sesiTidakBerlaku(error) {
  const res = error && error.response;

  if (!res) {
    return false;
  }

  const meta = res.data && res.data.meta;

  return res.status === 401 || !!(meta && meta.code == 401);
}

async function checkEmailPasswordEkyc(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, { headers: header() });
    const user = response.data;

    // Respons 401 datang sebagai HTTP 200 dengan meta.code 401 dan data kosong.
    // Tanpa `return`, alur lanjut membaca `user.data.role.name` pada data kosong,
    // melempar TypeError, dan berakhir di catch — user ter-logout tanpa sebab jelas.
    if (user && user.meta && user.meta.code == 401) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    const roleName = user && user.data && user.data.role && user.data.role.name;

    if (!roleName || !['mitra', 'funder-personal', 'funder-non-personal', 'marketing-agency'].includes(roleName)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    if (!user.data.email_verified_at) {
      return next({ name: 'waitingVerifiedEmail' });
    } else if (
      (user.data.role_id == 3 || user.data.role_id == 4) && !user.data.user_tilaka ||
      (user.data.role_id == 3 || user.data.role_id == 4) && !user.data.user_tilaka.register_id ||
      (user.data.role_id == 3 || user.data.role_id == 4) && !user.data.user_tilaka.reg_status ||
      (user.data.role_id == 3 || user.data.role_id == 4) && user.data.user_tilaka.reg_manual_registration_status && user.data.user_tilaka.reg_manual_registration_status == 'P' ||
      (user.data.role_id == 3 || user.data.role_id == 4) && user.data.user_tilaka.reg_manual_registration_status && user.data.user_tilaka.reg_manual_registration_status == 'I'
    ) {
      return next({ name: 'EkycVerify' });
    } else if ((user.data.role_id == 3 || user.data.role_id == 4) && user.data.user_tilaka && !user.data.user_tilaka.is_revoke_request && user.data.user_tilaka.cer_status == 2) {
      return next({ name: 'EkycPenautan' });
    } else if (
      (user.data.role_id == 3 || user.data.role_id == 4) &&
      user.data.user_tilaka &&
      user.data.user_tilaka.username &&
      (user.data.user_tilaka.reg_status == 'S' || user.data.user_tilaka.reg_manual_registration_status == 'S') &&
      user.data.user_tilaka.cer_status == 0
    ) {
      return next({ name: 'EkycFunderReEnrollRegister' });
    } else if (
      (user.data.role_id == 3 || user.data.role_id == 4) &&
      user.data.user_tilaka &&
      user.data.user_tilaka.username &&
      user.data.user_tilaka.re_enroll_id &&
      user.data.user_tilaka.cer_status == 2
    ) {
      return next({ name: 'EkycFunderReEnrollPenautan' });
    } else if (user.data.is_default_password == true) {
      return next({ name: 'defaultPasswordChange' });
    } else {
      return next();
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

async function isNotDefaultPassword(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, { headers: header() });
    const user = response.data;
    if (user.data.is_default_password == false) {
      next({ name: 'Index' });
    } else {
      next();
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

async function isNotEkycRegistered(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, { headers: header() });
    const user = response.data;
    if ((user.data.role_id != 3 && user.data.role_id != 4) || user.data.user_tilaka && user.data.user_tilaka.register_id && user.data.user_tilaka.reg_status) {
      if (
        (user.data.role_id == 3 || user.data.role_id == 4) && user.data.user_tilaka.reg_manual_registration_status && user.data.user_tilaka.reg_manual_registration_status == 'P' ||
        (user.data.role_id == 3 || user.data.role_id == 4) && user.data.user_tilaka.reg_manual_registration_status && user.data.user_tilaka.reg_manual_registration_status == 'I') {
        next();
      } else {
        next({ name: 'Index' });
      }
      console.log("user data  : ", user.data.user_tilaka.register_id);
    } else {
      next();
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

async function isNotEkycPenautan(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, { headers: header() });
    const user = response.data;
    if ((user.data.role_id != 3 && user.data.role_id != 4) || user.data.user_tilaka && user.data.user_tilaka.register_id && user.data.user_tilaka.cer_status != 2) {
      next({ name: 'Index' });
    } else {
      next();
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

async function isNotEkycReEnrollRegistered(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, {
      headers: header(),
    });
    const user = response.data;
    if (
      (user.data.role_id == 3 || user.data.role_id == 4) &&
      user.data.user_tilaka &&
      user.data.user_tilaka.register_id &&
      user.data.user_tilaka.username &&
      (user.data.user_tilaka.reg_status == 'S' || user.data.user_tilaka.reg_manual_registration_status == 'S') &&
      user.data.user_tilaka.cer_status == 0
    ) {
      next();
    } else {
      next({ name: "Index" });
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

async function isNotEkycReEnrollPenautan(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, {
      headers: header(),
    });
    const user = response.data;
    if (
      (user.data.role_id == 3 || user.data.role_id == 4) &&
      user.data.user_tilaka &&
      user.data.user_tilaka.register_id &&
      user.data.user_tilaka.username &&
      user.data.user_tilaka.re_enroll_id &&
      user.data.user_tilaka.cer_status == 2
    ) {
      next();
    } else {
      next({ name: "Index" });
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

async function isNotEmailVerified(to, from, next) {
  try {
    const response = await axios.get(process.env.API_URL + `/api/v3/auth/me`, { headers: header() });
    const user = response.data;
    if (user.data.email_verified_at) {
      next({ name: 'Index' });
    } else {
      next();
    }
  } catch (error) {
    console.error('Error fetching user data:', error);

    if (sesiTidakBerlaku(error)) {
      localStorage.removeItem('user');
      return next({ name: 'Login' });
    }

    // Gangguan sementara: biarkan halaman terbuka. Kalau token memang sudah mati,
    // request halaman itu sendiri akan membalas 401 dan interceptor global yang
    // membereskan sesinya.
    return next();
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/efunding'
    },
    // {
    //   path: '/main',
    //   name: 'Index',
    //   component: Main
    // },
    {
      path: '/efunding',
      name: 'Index',
      components: {
        default: Index,
        navbar: NewNavbar,
      }
    },
    {
      path: '/syarat-dan-ketentuan',
      name: 'Syarat',
      components: {
        default: Syarat,
        navbar: NewNavbar,
      }
    },
    {
      path: '/kebijakan-privasi',
      name: 'Privasi',
      components: {
        default: Privasi,
        navbar: NewNavbar,
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      components: {
        default: DashboardMitra,
        navbar: Navbar
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/dashboard2',
      name: 'Dashboard',
      components: {
        default: Dashboard,
        navbar: Navbar
      }
    },
    {
      path: '/add-product',
      name: 'Add Product',
      components: {
        default: ProductForm,
        navbar: Navbar
      },
      props: true,
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/add-pembiayaan',
      name: 'Add Pembiayaan',
      components: {
        default: PembiayaanForm,
        navbar: Navbar
      },
      props: true,
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/edit-product/:id',
      name: 'EditProduct',
      components: {
        default: ProductForm,
        navbar: Navbar
      },
      props: true,
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/edit-pembiayaan/:id',
      name: 'EditPembiayaan',
      components: {
        default: PembiayaanForm,
        navbar: Navbar
      },
      props: true,
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/add-bank',
      name: 'Add Bank',
      components: {
        default: BankForm,
        navbar: Navbar
      },
      props: true,
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/edit-bank/:id',
      name: 'EditBank',
      components: {
        default: BankForm,
        navbar: Navbar
      },
      props: true,
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/wait-verify-email',
      name: 'waitingVerifiedEmail',
      component: waitingVerifiedEmail,
      beforeEnter: isNotEmailVerified,
    },
    {
      path: '/ekyc-verify',
      name: 'EkycVerify',
      component: () => import("@/public/auth/EkycVerify.vue"),
      beforeEnter: isNotEkycRegistered,
    },
    {
      path: '/ekyc-response',
      name: 'EkycResponse',
      component: () => import("@/public/auth/EkycResponse.vue"),
      // beforeEnter: isNotEkycRegistered,
    },
    {
      path: '/ekyc-penautan',
      name: 'EkycPenautan',
      component: () => import("@/public/auth/EkycPenautan.vue"),
      beforeEnter: isNotEkycPenautan,
    },
    {
      path: '/ekyc-penautan-response',
      name: 'EkycPenautanResponse',
      component: () => import("@/public/auth/EkycPenautanResponse.vue"),
      // beforeEnter: isNotEkycPenautan,
    },
    {
      path: '/ekyc-funder/re-enroll/register',
      name: 'EkycFunderReEnrollRegister',
      component: () => import("@/public/auth/EkycFunderReEnrollRegister.vue"),
      beforeEnter: isNotEkycReEnrollRegistered,
    },
    {
      path: '/ekyc-funder/re-enroll/register-response',
      name: 'EkycFunderReEnrollRegisterResponse',
      component: () => import("@/public/auth/EkycFunderReEnrollRegisterResponse.vue"),
      // beforeEnter: isNotEkycReEnrollRegistered,
    },
    {
      path: '/ekyc-funder/re-enroll/penautan',
      name: 'EkycFunderReEnrollPenautan',
      component: () => import("@/public/auth/EkycFunderReEnrollPenautan.vue"),
      beforeEnter: isNotEkycReEnrollPenautan,
    },
    {
      path: '/ekyc-funder/re-enroll/penautan-response',
      name: 'EkycFunderReEnrollPenautanResponse',
      component: () => import("@/public/auth/EkycFunderReEnrollPenautanResponse.vue"),
      // beforeEnter: isNotEkycReEnrollPenautan,
    },
    {
      path: '/ekyc-mitra-verify/:key',
      name: 'EkycMitraVerify',
      component: () => import("@/public/auth/EkycMitraVerify.vue"),
    },
    {
      path: '/ekyc-mitra-ganti-signature/:key',
      name: 'EkycMitraGantiSignature',
      component: () => import("@/public/auth/EkycMitraGantiSignature.vue"),
    },
    {
      path: '/ekyc-mitra-response/:key',
      name: 'EkycMitraResponse',
      component: () => import("@/public/auth/EkycMitraResponse.vue"),
    },
    {
      path: '/ekyc-mitra-penautan/:key',
      name: 'EkycMitraPenautan',
      component: () => import("@/public/auth/EkycMitraPenautan.vue"),
    },
    {
      path: '/ekyc-mitra-penautan-response/:key',
      name: 'EkycMitraPenautanResponse',
      component: () => import("@/public/auth/EkycMitraPenautanResponse.vue"),
    },
    {
      path: '/ekyc-mitra/re-enroll/register/:key',
      name: 'EkycMitraReEnrollRegister',
      component: () => import("@/public/auth/EkycMitraReEnrollRegister.vue"),
    },
    {
      path: '/ekyc-mitra/re-enroll/register-response/:key',
      name: 'EkycMitraReEnrollRegisterResponse',
      component: () => import("@/public/auth/EkycMitraReEnrollRegisterResponse.vue"),
    },
    {
      path: '/ekyc-mitra/re-enroll/webview/:key',
      name: 'EkycMitraReEnrollWebview',
      component: () => import("@/public/auth/EkycMitraReEnrollWebview.vue"),
    },
    {
      path: '/ekyc-mitra/re-enroll/webview-aktivasi/:key',
      name: 'EkycMitraReEnrollWebviewAktivasi',
      component: () => import("@/public/auth/EkycMitraReEnrollWebviewAktivasi.vue"),
    },
    {
      path: '/ekyc-mitra/re-enroll/penautan/:key',
      name: 'EkycMitraReEnrollPenautan',
      component: () => import("@/public/auth/EkycMitraReEnrollPenautan.vue"),
    },
    {
      path: '/ekyc-mitra/re-enroll/penautan-response/:key',
      name: 'EkycMitraReEnrollPenautanResponse',
      component: () => import("@/public/auth/EkycMitraReEnrollPenautanResponse.vue"),
    },
    {
      path: '/ekyc-funder-verify/:key',
      name: 'EkycFunderVerify',
      component: () => import("@/public/auth/EkycFunderVerify.vue"),
    },
    {
      path: '/ekyc-funder-response/:key',
      name: 'EkycFunderResponse',
      component: () => import("@/public/auth/EkycFunderResponse.vue"),
    },
    {
      path: '/ekyc-funder-ganti-signature/:key',
      name: 'EkycFunderGantiSignature',
      component: () => import("@/public/auth/EkycFunderGantiSignature.vue"),
    },
    {
      path: '/ekyc-funder-penautan/:key',
      name: 'EkycFunderPenautan',
      component: () => import("@/public/auth/EkycFunderPenautan.vue"),
    },
    {
      path: '/ekyc-funder-penautan-response/:key',
      name: 'EkycFunderPenautanResponse',
      component: () => import("@/public/auth/EkycFunderPenautanResponse.vue"),
    },
    {
      path: '/ekyc-funder/re-enroll/register/:key',
      name: 'EkycFunderLinkReEnrollRegister',
      component: () => import("@/public/auth/EkycFunderLinkReEnrollRegister.vue"),
    },
    {
      path: '/ekyc-funder/re-enroll/register-response/:key',
      name: 'EkycFunderLinkReEnrollRegisterResponse',
      component: () => import("@/public/auth/EkycFunderLinkReEnrollRegisterResponse.vue"),
    },
    {
      path: '/ekyc-funder/re-enroll/webview/:key',
      name: 'EkycFunderLinkReEnrollWebview',
      component: () => import("@/public/auth/EkycFunderLinkReEnrollWebview.vue"),
    },
    {
      path: '/ekyc-funder/re-enroll/webview-aktivasi/:key',
      name: 'EkycFunderLinkReEnrollWebviewAktivasi',
      component: () => import("@/public/auth/EkycFunderLinkReEnrollWebviewAktivasi.vue"),
    },
    {
      path: '/ekyc-funder/re-enroll/penautan/:key',
      name: 'EkycFunderLinkReEnrollPenautan',
      component: () => import("@/public/auth/EkycFunderLinkReEnrollPenautan.vue"),
    },
    {
      path: '/ekyc-funder/re-enroll/penautan-response/:key',
      name: 'EkycFunderLinkReEnrollPenautanResponse',
      component: () => import("@/public/auth/EkycFunderLinkReEnrollPenautanResponse.vue"),
    },
    {
      path: '/sign-auth/:key/:id',
      name: 'SignAuth',
      component: () => import("@/public/auth/SignAuth.vue"),
    },
    {
      path: '/sign-response/:key',
      name: 'SignResponse',
      component: () => import("@/public/auth/SignResponse.vue"),
    },
    {
      path: '/pengajuan-lending/sign-auth/:key/:id',
      name: 'LendingSignAuth',
      component: () => import("@/public/auth/LendingSignAuth.vue"),
    },
    {
      path: '/pengajuan-lending/sign-response/:key',
      name: 'LendingSignResponse',
      component: () => import("@/public/auth/LendingSignResponse.vue"),
    },
    {
      path: '/default-password-change',
      name: 'defaultPasswordChange',
      component: defaultPasswordChange,
      beforeEnter: isNotDefaultPassword
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: () => import("@/public/auth/AgreementPage.vue"),
    },
    {
      path: '/verify',
      name: 'Verifikasi Email',
      component: EmailVerified
    },
    {
      path: '/revision-profile',
      name: 'Perbaikan Data Diri',
      component: RevisionProfile
    },
    {
      path: '/forgot-password',
      name: 'LupaPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
    },
    {
      path: '/atur-ulang-password/:token',
      name: 'AturUlangPassword',
      component: () => import("@/public/auth/AturUlangPassword.vue"),
    },
    {
      path: '/list-produk',
      name: 'List Produk',
      components: {
        default: ListProduk,
        navbar: Navbar,
      }
    },
    {
      path: '/detail-produk/:id',
      name: 'DetailProduk',
      components: {
        default: DetailProduk,
        navbar: Navbar,
      }
    },
    {
      path: '/list-produk-lending',
      name: 'List Produk',
      components: {
        default: ListProdukLending,
        navbar: NewNavbar,
      }
    },
    {
      path: '/list-produk-deposito',
      name: 'List Produk',
      components: {
        default: ListProdukDeposito,
        navbar: NewNavbar,
      }
    },
    {
      path: '/list-produk-deposito-detail',
      name: 'List Produk',
      components: {
        default: ListProdukDepositoDetail,
        navbar: NewNavbar,
      }
    },
    {
      path: '/list-produk-tabungan',
      name: 'List Produk',
      components: {
        default: ListProdukTabungan,
        navbar: NewNavbar,
      }
    },
    {
      path: '/list-produk-tabungan-detail',
      name: 'List Produk',
      components: {
        default: ListProdukTabunganDetail,
        navbar: NewNavbar,
      }
    },
    {
      path: '/layanan-kami',
      name: 'layanan_kami',
      components: {
        default: LayananKami,
        navbar: NewNavbar,
      }
    },
    {
      path: '/detail-produk-lending',
      name: 'Detail Produk Lending',
      components: {
        default: DetailProdukLending,
        navbar: NewNavbar,
      }
    },
    {
      path: '/list-lending-detail',
      name: 'list_lending_detail',
      components: {
        default: ListLendingDetail,
        navbar: NewNavbar,
      },
      props: true
    },
    {
      path: '/detail-produk-lending',
      name: 'detail_produk_lending',
      components: {
        default: ProductLendingDetail,
        navbar: NewNavbar,
      },
      props: true
    },
    {
      path: '/pengajuan-saya',
      name: 'Pengajuan Saya',
      components: {
        default: PengajuanSaya,
        navbar: Navbar,
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/agency/dashboard',
      name: 'Dashboard Agen',
      components: {
        default: AgencyDashboard,
        navbar: Navbar,
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/riwayat',
      name: 'Riwayat',
      components: {
        default: PengajuanSaya,
        navbar: Navbar,
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/pengajuan-saya2',
      name: 'Pengajuan Saya',
      components: {
        default: PengajuanSaya2,
        navbar: Navbar,
      }
    },
    {
      path: '/produk-mitra/:id',
      name: 'Produk Mitra',
      components: {
        default: ProdukMitra,
        navbar: Navbar
      }
    },
    {
      path: '/show-pengajuan/:funderId/:pengajuanId',
      name: 'ShowPengajuan',
      components: {
        default: ShowPengajuan,
        navbar: Navbar
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/show-pengajuan-corporate/:funderId/:pengajuanId',
      name: 'ShowPengajuanCorporate',
      components: {
        default: ShowPengajuanCorporate,
        navbar: Navbar
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/show-pengajuan-lending/:funderId/:pengajuanId',
      name: 'ShowPengajuanLending',
      components: {
        default: ShowPengajuanLending,
        navbar: Navbar
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/show-funder/:funderId',
      name: 'ShowFunder',
      components: {
        default: ShowFunder,
        navbar: Navbar
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/show-funder-corporate/:funderId',
      name: 'ShowFunder',
      components: {
        default: ShowFunderCorporate,
        navbar: Navbar
      },
      beforeEnter: checkEmailPasswordEkyc
    },
    {
      path: '/tabs/',
      name: 'Tabs',
      components: {
        default: Tabs,
      }
    },
    {
      path: '/testimoni-umum/',
      name: 'Testimoni Umum',
      components: {
        default: TestimoniUmum,
        navbar: Navbar
      }
    },
    {
      path: '/tentang-kami/',
      name: 'Tentang Kami',
      components: {
        default: TentangKami,
        navbar: NewNavbar
      }
    },
    {
      path: '/hubungi-kami/',
      name: 'Hubungi Kami',
      components: {
        default: ContactUs,
        navbar: NewNavbar
      }
    },
    {
      path: '/faq/',
      name: 'Faq',
      components: {
        default: Faq,
        navbar: NewNavbar
      }
    },
    {
      path: '/whistleblower/',
      name: 'Whistleblower',
      components: {
        default: Whistleblower,
        navbar: NewNavbar
      }
    },
    {
      path: '/tovo/home-one',
      name: 'Home_one',
      components: {
        default: Homeone,
        navbar: Navbar,
      }

    },
    {
      path: '/tovo/home-two',
      name: 'Home_two',
      components: {
        default: Hometwo,
        navbar: Navbar,
      }
    },
    {
      path: '/tovo/home-three',
      name: 'Home_three',
      components: {
        default: Homethree,
        navbar: Navbar,
      }
    },
    {
      path: '/tovo/404',
      name: 'pagenotfound',
      component: PageNotFound
    },
    {
      path: '/tovo/blog-list',
      name: 'blog_list',
      components: {
        default: Bloglist,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-details',
      name: 'Blog_details',
      components: {
        default: BlogDetails,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-leftside',
      name: 'Blog_leftside',
      components: {
        default: BlogLeftSide,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-rightside',
      name: 'Blog_rightside',
      components: {
        default: BlogRightSide,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-left-sidebar',
      name: 'BlogLeftSidebar',
      components: {
        default: BlogLeftSidebar,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/blog-right-sidebar',
      name: 'BlogrightSidebar',
      components: {
        default: BlogRightSidebar,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/sign-in',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/tovo/sign-up',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/tovo/forget-Password',
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/tovo/thank-you',
      name: 'Thankyou',
      component: Thankyou
    },
    {
      path: '/tovo/review',
      name: 'Review',
      components: {
        default: Review,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/faq',
      name: 'Faq',
      components: {
        default: Faq,
        navbar: NavbarBlog,
      }
    },
    {
      path: '/tovo/download',
      name: 'download',
      component: download
    },
    {
      path: '/tovo/coming-soon',
      name: 'coming_soon',
      component: comingsoon
    },
    {
      path: '/tovo/email-template',
      name: 'Emailtemplate',
      component: Emailtemplate
    },
    {
      path: '*',
      redirect: '/tovo/404'
    },
    {
      path: '/new-register',
      components: {
        default: NewRegister,
      }
    },
    {
      path: '/new-login',
      components: {
        default: NewLogin,
      }
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  // Prevent infinite loops on public/auth routes
  if (to.name === 'Agreement' || to.name === 'Login' || to.name === 'Register' || to.name === 'ForgetPassword' || to.name === 'ResetPassword' || to.name === 'AturUlangPassword') {
    return next();
  }

  const userStr = localStorage.getItem('user');
  if (!userStr) {
    return next(); // Not logged in, let other route guards handle it
  }

  let userData;
  try {
    userData = JSON.parse(userStr);
  } catch (e) {
    return next();
  }

  if (!userData || !userData.info) {
    return next();
  }

  const user = userData.info;

  // Aturan pengecekannya dipakai bersama halaman login, lihat helpers/agreementStatus.js
  const agreementStatus = await checkAgreementStatus(user);

  if (agreementStatus.unauthenticated) {
    localStorage.removeItem('user');
    return next({ name: 'Login' });
  }

  if (agreementStatus.needAgreement) {
    return next({ name: 'Agreement' });
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js